import { HOSPITAL_IMAGES, HOSPITAL_LAB, HOSPITAL_SHOES, HOSPITAL_SURGERY_ROUTE } from '../../../routes/urls';
import { ServiceType } from './types';

/**
 * SHER-411 — after completing a request action, navigate back to the list for the
 * same module (lab / radiology / cordonnerie / surgery), not a hard-coded fallback.
 */
export function requestModuleHomePath(serviceType: number): string {
    switch (serviceType) {
        case ServiceType.LABORATORY:
            return HOSPITAL_LAB;
        case ServiceType.SURGERY:
            return HOSPITAL_SURGERY_ROUTE;
        case ServiceType.SHOE:
            return HOSPITAL_SHOES;
        case ServiceType.IMAGING:
            return HOSPITAL_IMAGES;
        default:
            return HOSPITAL_IMAGES;
    }
}
